import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const tagMarkerArrow: SystemStyleObject = {
  content: "''",
  width: "0",
  height: "0",
  borderLeft: "8px solid transparent",
  borderRight: "8px solid transparent",
  borderTop: "8px solid #4ec2fd",
  position: "absolute",
  bottom: "-7px",
};

export const tagMarkerArrowBorder: SystemStyleObject<Theme> = {
  content: "''",
  width: "0",
  height: "0",
  borderLeft: "8px solid transparent",
  borderRight: "8px solid transparent",
  borderTop: ({ palette }) => `8px solid ${palette.tagBorder.primary}`,
  position: "absolute",
  bottom: "-8px",
};

export const classes: Record<string, SystemStyleObject<Theme>> = {
  tagMarker: {
    background: "#4ec2fd",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    borderRadius: "4px",
    fontSize: "12px",
    padding: ({ spacing }) => `${spacing(0.5)} ${spacing(2)}`,
    position: "absolute",
    cursor: "pointer",
    bottom: "90px",
    transform: "translateX(-50%)",
    transition: "all 0.3s ease",
    border: ({ palette }) => `1px solid ${palette.tagBorder.primary}`,
    zIndex: 1,

    ".title": {
      fontSize: "10px",
    },

    "&:hover": {
      transform: "translateX(-50%) translateY(-20%)",
      zIndex: 2,
    },

    "&::before": tagMarkerArrowBorder,
  },

  markerName: {
    display: "grid",
  },
};
